import moment from 'moment-timezone'
import store from '@/store'

export const diasSemana = [
  {
    value: 'lunes',
    text: 'Lunes'
  },
  {
    value: 'martes',
    text: 'Martes'
  },
  {
    value: 'miercoles',
    text: 'Miércoles'
  },
  {
    value: 'jueves',
    text: 'Jueves'
  },
  {
    value: 'viernes',
    text: 'Viernes'
  },
  {
    value: 'sabado',
    text: 'Sábado'
  },
  {
    value: 'domingo',
    text: 'Domingo'
  },
]

export const parDiasComparar = (dia = null) => {
  if (!dia) {
    dia = moment().hour();
  }
  let hora = store.state.horaInicio;
  let actual = dia
  var res = [];
  let m = moment().hour(parseInt(hora)).minute(0).seconds(0);
  if (actual >= hora) {
    let hoy = m.toDate();
    let tomorrow = m.add(1, 'days').toDate()
    res = [hoy, tomorrow];
  } else {
    let hoy = m.toDate();
    let ayer = m.subtract(1, 'days').toDate()
    res = [ayer, hoy];
  }
  return res;
}
